const canUseAnalytics = () =>
  typeof window !== "undefined" && typeof window.gtag === "function";

const getLocationValue = (location, key) => {
  if (location && typeof location[key] === "string") {
    return location[key];
  }

  if (
    typeof window !== "undefined" &&
    window.location &&
    typeof window.location[key] === "string"
  ) {
    return window.location[key];
  }

  return "";
};

/**
 * Sends a GA4 event when the browser analytics client is available.
 * Returns false during SSR or when GA4 is disabled/not ready.
 */
export const trackEvent = (eventName, params = {}) => {
  if (!canUseAnalytics() || typeof eventName !== "string" || !eventName) {
    return false;
  }

  window.gtag(
    "event",
    eventName,
    params && typeof params === "object" ? params : {},
  );

  return true;
};

/**
 * Sends an explicit GA4 page_view for Gatsby client-side navigation.
 * The initial page view remains owned by the GA4 config in gatsby-ssr.js.
 */
export const trackPageView = (location) => {
  if (typeof window === "undefined") return false;

  const pathname = getLocationValue(location, "pathname") || "/";
  const search = getLocationValue(location, "search");
  const hash = getLocationValue(location, "hash");
  const pagePath = `${pathname}${search}`;

  let pageLocation =
    location && typeof location.href === "string" ? location.href : "";

  if (!pageLocation && window.location) {
    try {
      pageLocation = new URL(`${pagePath}${hash}`, window.location.origin).href;
    } catch {
      pageLocation = window.location.href;
    }
  }

  return trackEvent("page_view", {
    page_path: pagePath,
    page_location: pageLocation,
    page_title: typeof document !== "undefined" ? document.title : "",
  });
};
